type Parser<T> = ( raw?: string ) => T;

export class EnvVar<T = string> {
  private key: string;
  private raw?: string;
  val: T;

  constructor( key: string, envStr: string | undefined, parser: Parser<T> ) {
    this.key = key;
    this.raw = envStr;
    this.val = parser( envStr );
  }

  static string( key: string, envStr: string | undefined ) {
    return new EnvVar<string>(
      key,
      envStr,
      ( v?: string ) => {
        if( !v ) return ''; // default

        return v;
      }
    );
  }

  static boolean( key: string, envStr: string | undefined ) {
    return new EnvVar<boolean>(
      key,
      envStr,
      ( v?: string ) => {
        if( !v || v.length === 0 ) return false; // default

        return v.toLowerCase() === 'true';
      }
    );
  }

  static number( key: string, envStr: string | undefined ) {
    return new EnvVar<number>(
      key,
      envStr,
      ( v?: string ) => {
        if( !v ) return 0; // default

        const n = Number( v );
        if ( Number.isNaN( n ) ) {
          console.error( `Invalid number for ${ envStr }` );
          return 0;
        }

        return n;
      }
    );
  }
}